module.exports = __webpack_public_path__ + "img/test-filter.f9323a40.png";